module.exports = __webpack_public_path__ + "img/BackgroundCourier.f62cb93b.svg";